export enum TimeRange {
  days1 = '1d',
  weeks1 = '1w',
  months1 = '1m',
  months3 = '3m',
  months6 = '6m',
  ytd = 'ytd',
  years1 = '1y',
  years5 = '5y',
}

export interface IntervalStats {
  max_drawdown: number;
  total_return: number;
  sharpe: number;
  volatility: number;
  excess_return: number | null;
  correlation: number;
  beta: number | null;
  plot_data: { date: string; portfolio: number; benchmark: number }[];
}

export type IntervalStatsMap = Record<string, IntervalStats>;
